import React from 'react'

import { AlignItems, Box, Display, Heading4, Join, Space } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { Equipment } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { menuPreferencesVisibilityChange } from 'actions/menu'
import { EquipmentBanner } from 'routes/Menu/components/Detail/Equipment/EquipmentBanner'
import { SectionPanel } from 'routes/Menu/components/Detail/SectionPanel'
import { RecipeAttributePill } from 'routes/Menu/components/RecipeAttributePill/RecipeAttributePill'
import { useAuth } from 'routes/Menu/domains/auth'

type RecipeEquipmentProps = {
  equipment?: RecipeQueryResponse['equipment']
  loading: boolean
  onClose: () => void
}

export const RecipeEquipment = ({ equipment, loading, onClose }: RecipeEquipmentProps) => {
  const dispatch = useDispatch()
  const { isAuthenticated } = useAuth()

  if (!equipment?.list?.length || loading) {
    return null
  }

  const mappedEquipment: Equipment[] = equipment.list.map((item) => ({
    name: item.name,
    is_missing: item.missing,
  }))

  const openMenuPreferences = () => {
    onClose()
    dispatch(menuPreferencesVisibilityChange(true))
  }

  return (
    <SectionPanel>
      <Join with={<Space size={3} />}>
        <Heading4>Equipment Needed</Heading4>
        <Box alignItems={AlignItems.FlexStart} wrap display={Display.Flex}>
          {mappedEquipment.map((item) => (
            <RecipeAttributePill key={item.name} icon="equipment" text={item.name} />
          ))}
        </Box>
        {isAuthenticated && (
          <EquipmentBanner equipment={mappedEquipment} onClick={openMenuPreferences} />
        )}
      </Join>
    </SectionPanel>
  )
}
